import { signalStoreFeature, withState } from '@ngrx/signals';
import { on, withReducer } from '@ngrx/signals/events';
import { signingInviteEvents } from './events';
import type {
  SigningInvitePage,
  SigningInviteAccepted,
} from '../../schemas/generated/vantage-api.schemas';

export interface SigningInviteState {
  /** What the invite points at, once looked up — the signing page's whole render input. */
  page: SigningInvitePage | null;
  /** The receipt of a successful redeem — quote number, status, and the sealed content hash the
   * signer can later check their retained copy against. */
  accepted: SigningInviteAccepted | null;
  loading: boolean;
  redeeming: boolean;
  error: string | null;
  /** The backend refusal `code`, kept beside the message so the page can distinguish a dead link
   * from a mid-review quote change without string-matching prose. */
  errorCode: string | null;
}

export const initialSigningInviteState: SigningInviteState = {
  page: null, accepted: null, loading: false, redeeming: false, error: null, errorCode: null,
};

export function withSigningInviteReducer() {
  return signalStoreFeature(
    withState<SigningInviteState>(initialSigningInviteState),
    withReducer(
      on(signingInviteEvents.lookup, () => ({ loading: true, error: null, errorCode: null })),
      on(signingInviteEvents.lookupSuccess, ({ payload: page }) => ({ page, loading: false })),
      on(signingInviteEvents.lookupFailed, ({ payload }) => ({
        error: payload.message, errorCode: payload.code, loading: false,
      })),
      on(signingInviteEvents.redeem, () => ({ redeeming: true, error: null, errorCode: null })),
      on(signingInviteEvents.redeemSuccess, ({ payload: accepted }) => ({ accepted, redeeming: false })),
      on(signingInviteEvents.redeemFailed, ({ payload }) => ({
        error: payload.message, errorCode: payload.code, redeeming: false,
      })),
    ),
  );
}
